import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class SmartTeamsUserProfile extends MongoEntity {
  static override _class = 'SmartTeamsUserProfile';
  static override _collectionName = 'smartteams_user_profiles';

  @validate(nonOptional())
  @Field(() => String)
  userId: Maybe<string>; // Reference to AdornisUser._id

  @Field(() => String)
  displayName: Maybe<string>;

  @Field(() => String)
  phone: Maybe<string>;

  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;
}
